/* eslint-disable react/no-array-index-key */
import React, { FC } from 'react';
import { StyledSlider, StyledTrack, StyledRange, StyledThumb } from './Slider.styles';
import { Wrapper } from '../Wrapper/Wrapper';
import { Tooltip } from '../Tooltip/Tooltip';
import { MarginProps } from '../../../theme/styledProps';

// DOCS -> https://www.radix-ui.com/docs/primitives/components/slider
// This should strictly be used as a controlled component.

export interface SliderProps extends MarginProps {
  ariaLabels: string[];
  disabled?: boolean;
  min?: number;
  max?: number;
  step?: number;
  values: number[];
  minStepsBetweenThumbs?: number;
  onChange: (values: number[]) => void;
  showTooltip?: boolean;
}

export const Slider: FC<SliderProps> = ({
  ariaLabels,
  disabled,
  values,
  min,
  max,
  step,
  minStepsBetweenThumbs,
  onChange,
  showTooltip = true,
  ...rest
}) => {
  return (
    <Wrapper {...rest}>
      <StyledSlider
        disabled={disabled}
        value={values}
        min={min}
        max={max}
        step={step}
        minStepsBetweenThumbs={minStepsBetweenThumbs}
        onValueChange={onChange}
      >
        <StyledTrack disabled={disabled}>
          <StyledRange disabled={disabled} />
        </StyledTrack>
        {values.map((sliderValue, i) =>
          showTooltip ? (
            <Tooltip
              content={sliderValue}
              placement="top"
              visible
              variant="slider"
              isAlt={disabled}
              key={i}
            >
              <StyledThumb $disabled={disabled} aria-label={ariaLabels[i]} />
            </Tooltip>
          ) : (
            <StyledThumb $disabled={disabled} aria-label={ariaLabels[i]} key={i} />
          ),
        )}
      </StyledSlider>
    </Wrapper>
  );
};
